<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }" v-if="ShowButton">
        <v-btn color="primary" class="white--text" v-bind="attrs"
          v-on="on">Thêm mới <v-icon right>mdi mdi-car-off</v-icon> </v-btn>

      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
        <v-card-title>
          <span class="text-h5" v-if="!addData.gtId">Thêm giấy tờ xe</span>
          <span class="text-h5" v-else>Cập nhật giấy tờ xe</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
              >
                <v-text-field
                  v-model="addData.BienSoXe"
                  label="Biển số xe:"
                  :rules="Rules.BienSo"
                  counter="9"
                  required
                  @change="CheckValid"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                  <v-btn color="#008a43" class="white--text" @click=TimKiem360 :loading=timkiem360 :disabled=timkiem360>Tìm 360 <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="addData.DangKiem"
                  label="Đăng kiểm:"
                  :rules="Rules.YeuCau"
                  required
                  @change="CheckValid"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="addData.DangKy"
                  label="Đăng ký:"
                  :rules="Rules.YeuCau"
                  required
                  @change="CheckValid"
                ></v-text-field>
              </v-col>
              <!-- <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-select
                  v-model="addData.LoaiXe"
                  :items="LoaiXe"
                  label="Loại xe:"
                  item-value="Value"
                  item-text="Text"
                  :rules="Rules.YeuCau"
                  required
                  @change="CheckValid"
                ></v-select>
              </v-col> -->
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-select
                  v-model="addData.Tram"
                  :items="Tram"
                  label="Trạm:"
                  item-value="StationsID"
                  item-text="StationsName"
                  :rules="Rules.YeuCau"
                  required
                  @change="CheckValid"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-file-input
                  accept="image/*"
                  label="Hình ảnh"
                  @change="selectFile"
                  :disabled="disabled"
                ></v-file-input>
                <v-progress-linear
                  v-model="progress"
                  color="light-blue"
                  height="25"
                  v-if="process > 0"
                  reactive
                >
                  <strong>{{ progress }} %</strong>
                </v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Đóng
          </v-btn>
          <v-btn
            color="green"
            :disabled="disabled"
            :loading="loading"            
            @click="TaoMoi"
            class="white--text"
            v-if="!addData.gtId"
          >
            Tạo
          </v-btn>
          <v-btn
            color="green"
            :loading="loading"            
            @click="CapNhat"
            class="white--text"
            v-else
          >
            Cập nhật
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    data: (vm) => ({
      currentFile: undefined,
      timkiem360:false,
      TrackTime: undefined,
      addData: {},
      dialog: false,
      loading:false,
      disabled: true,
      process: 0,
      Swal: vm.$swal,
      moment: vm.moment
    }),
    props: {
      Tram: Array,
      LoaiXe: Array,
      Rules: Object,
      isUpdated: Boolean,
      ShowButton: {
        type: Boolean,
        defaut: true,
        required: false,
      },
    },
    methods: {
      selectFile(file){
        this.progress = 0;
        this.currentFile = file;
      },
      UploadFile(type,onUploadProgress){
          let formData = new FormData();
          formData.append("file", this.currentFile);
          return this.$Request.post(`/upload/${type}/${this.addData.BienSoXe}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress
          });
      },
      EditItem(item){
        delete item.ThoiGian;
        this.addData = item;
        this.dialog = true;
        this.disabled = false;
      },
      TimKiem360(){
        this.timkiem360 = true;
        const biensoxe = this.addData.BienSoXe;
        this.$Request.get(`/360search/${biensoxe}`).then(response => {
            if(response.data.success === true)
            {
              const json = response.data.data;
              if(json.WEIGHT_GOODS) this.addData.DangKiem = json.WEIGHT_GOODS;
            }else{
              const msg = response.data.error || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.timkiem360 = false;
        });
      },
      async CapNhat(){
        this.loading = true;
        if(this.currentFile !== undefined){
          const file = await this.UploadFile("dangky-dangkiem",(event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
          });
          if(!file.data.data){
            this.Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: "Không thể thêm hình ảnh lên máy chủ !",
                    showConfirmButton: false,
                    timer: 1500
                });
            this.loading = false;
            return;
          }
          this.addData.HinhAnh = file.data.data;
        }
        this.$Request.post('/giaytoxe/update',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã cập nhật thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.msg || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      async TaoMoi(){
        this.loading = true;
        if(this.currentFile !== undefined){
          const file = await this.UploadFile("dangky-dangkiem",(event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
          });
          if(!file.data.data){
            this.Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: "Không thể thêm hình ảnh lên máy chủ !",
                    showConfirmButton: false,
                    timer: 1500
                });
            this.loading = false;
            return;
          }
          this.addData.HinhAnh = file.data.data;
        }
        this.$Request.post('/giaytoxe/create',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã thêm thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.error || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      CheckValid(){
        this.disabled = !this.$refs.form.validate();
      }
    },
    watch: {
      dialog: function(val){
        if(val === true){
          if(!this.addData.gtId){
            this.addData = {'BienSoXe':""};
          }
        }
      }
    },
    computed: {
      isValid(){
        if(typeof(this.$refs.form) === "undefined") return false;
        return this.$refs.form.validate();
      }
    },
    mounted(){
      this.process = 0;
    }
}
</script>